import "./Blog.module.css";
import Header from "@/reusable_sections/Header";
import ArticlesList from "./sections/ArticlesList";
import Footer from "@/reusable_sections/Footer";
export default function BlogPage() {
  return <div>
      <Header />
      <ArticlesList />
      <Footer />
    </div>;
}